"use client";

import SectionLayout from "@/components/ui/SectionLayout";
import React from "react";
import { CaseSectionProps } from "../model";
import { getDefaultCmsSection } from "@/utils/helper";
import FullFinancialFacts from "@/components/ui/FullFinancialFacts";
import RandomImage from "@/components/ui/RandomImage";
import Card from "@/components/ui/Card";

const CaseFinancialSection: React.FC<
  CaseSectionProps<{
    showStandardFinancing: boolean;
    card: { bgColor: string; textColor: string };
  }>
> = ({ cmsSection, caseData, cmsData }) => {
  if (!caseData.isActive) {
    return null;
  }

  const isSecondaryLayout = cmsData.layout?.name === "secondary";
  // The room under the photo is for the facts card hanging over its edge, which the Sekundær layout does not draw; there
  // the section's own Luft indeni is all the room below it. With explicit spacing it always is: explicitSpacingUpgrade
  // writes the room into Luft indeni (FINANCIAL_ROOM).
  const cardRoom =
    !isSecondaryLayout ||
    (!cmsSection.explicitSpacing && !cmsSection.ui?.padding);

  return (
    <SectionLayout
      cmsSection={getDefaultCmsSection(cmsSection)}
      ownHeight="content"
    >
      <div
        className={` h-[500px] flex md:flex-row flex-col relative justify-end md:items-start md:justify-start items-center${cardRoom ? " mb-36 md:mb-20" : ""}`}
      >
        {isSecondaryLayout ? null : (
          <div className="absolute md:-bottom-10 -bottom-32 z-10 w-[90%] md:w-[30rem]">
            <Card>
              <div
                style={{
                  backgroundColor: cmsSection.specifics?.card?.bgColor,
                  color: cmsSection.specifics?.card?.textColor,
                }}
              >
                <div className="p-4 pb-0 flex justify-between homepage-text-lg">
                  <div className="flex gap-2 items-center primary-font">
                    Økonomi
                  </div>
                </div>
                <FullFinancialFacts
                  caseData={caseData}
                  showStandardFinancing={
                    cmsSection.specifics.showStandardFinancing
                  }
                />
              </div>
            </Card>
          </div>
        )}
        {caseData?.images?.filter((x) => x.namespace.endsWith("photo"))
          ?.length > 0 && (
          <div
            className={`absolute inset-y-0 right-0 left-0 ${isSecondaryLayout ? "" : "md:left-20"} flex justify-end`}
          >
            <RandomImage
              images={caseData.images
                .filter((x) => x.namespace.endsWith("photo"))
                .slice(0, 9)}
            />
          </div>
        )}
      </div>
    </SectionLayout>
  );
};

export default CaseFinancialSection;
